module.exports = __webpack_public_path__ + "images/ds-cm-bg-hero-mobile.webp";